import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    startIndex: { type: Number, default: 0 },
    galleryId: { type: String, default: 'default' }
  }
  
  openGallery(event) {
    event.preventDefault()
    // Dispatch a global event to the window that includes the gallery ID
    this.dispatch("letsOpenThisGallery", {
      detail: {
        startIndex: this.startIndexValue,
        galleryId: this.galleryIdValue
      }
    }, { target: window })
  }
}
